'use strict';

var MyProfileController = require('./MyProfileController');

angular
  .module('settings.myProfile', [])
  .controller('MyProfileController', MyProfileController)
  .run(['UserStore', function (UserStore) {
    UserStore.init();
  }]);



// WEBPACK FOOTER //
// ./src/app/settings/myProfile/index.js